import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../api';
import { consumeReturnPath } from '../returnPath';
import './Auth.css';

function SsoLogin({ setIsAuthenticated }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;

    async function run() {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const token = params.get('token');
      if (!code && !token) {
        if (mounted) setError('Missing SSO code or token.');
        return;
      }

      try {
        const response = await api.post(
          '/api/sso-login',
          code ? { code } : { token },
        );
        localStorage.setItem('token', response.data.access_token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        setIsAuthenticated(true);
        navigate(consumeReturnPath() || '/dashboard', { replace: true });
      } catch (err) {
        if (!mounted) return;
        setError(err.response?.data?.error || 'SSO login failed.');
      }
    }

    run();
    return () => {
      mounted = false;
    };
  }, [location.search, navigate, setIsAuthenticated]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Invoice Generator</h1>
        <h2>The Castle Pub GmbH</h2>
        <p style={{ marginTop: '1rem', color: '#666' }}>Signing you in from Admin Hub…</p>
        {error && (
          <>
            <div className="error" style={{ marginTop: '1rem' }}>{error}</div>
            <button
              type="button"
              className="btn btn-primary"
              style={{ marginTop: '1rem' }}
              onClick={() => navigate('/login', { replace: true })}
            >
              Go to login
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default SsoLogin;
